angular.module('impactx.rfx').controller('RFXSupplierEditItemCtrl', [
    'TranslationService',
    '$mdDialog',
    'AppConfiguration',
    'dataGen',
    RFXSupplierEditItemCtrl
]);

function RFXSupplierEditItemCtrl(TranslationService, $mdDialog, AppConfiguration, dataGen) {
    var self = this;
    self.itemCopy = angular.copy(self.item, self.itemCopy);
    self.trns.save = TranslationService.get('accept');
    self.trns.abort = TranslationService.get('abort');
    self.trns.noSelectedItemMessageLabel = TranslationService.get("noSelectedItemMessage");
    self.freeformOfferLotSelect = AppConfiguration.get('freeformOfferLotSelect');
    self.oldContractSelected = 0;
    self.selectCurrency = !self.itemCopy.csc;

    self.onContractSelect = function(selected) {
        if(selected && selected.id != self.oldContractSelected) {
            var tempScope = {};
            dataGen.getData(tempScope, {cscId: selected.id, supplierSide: true, orderCOMId : self.itemCopy.orderCOMId}, "/rfx/contract/updatedata").then(function() {
                if (self.selectCurrency) {
                    if (tempScope.data.cscCurrencySelected && tempScope.data.cscCurrencySelected.selected) {
                        for (var i = 0; i < self.itemCopy.price.currency.entries.length; i++) {
                            if (self.itemCopy.price.currency.entries[i].id === tempScope.data.cscCurrencySelected.selected.id) {
                                self.itemCopy.price.currency.selected = self.itemCopy.price.currency.entries[i];
                                self.selectCurrency = false;
                            }
                        }
                    }
                }
                self.itemCopy.comments.externalComments.attachmentRequired.value = tempScope.data.attachmentRequired;
                self.itemCopy.comments.externalComments.attachmentsAllowed = tempScope.data.attachmentsAllowed;
                if (self.itemCopy.eClassSelection) {
                    self.itemCopy.eClassSelection.showMust = tempScope.data.newData.ffMandatoryEClassSupplier;
                }
                if (!self.itemCopy.naBeSelection) {
                    self.itemCopy.naBeSelection = tempScope.data.newData.naBeSelection;
                }
                else if (!tempScope.data.newData.naBeSelection) {
                    self.itemCopy.naBeSelection = null;
                }
                else {
                    if (self.itemCopy.naBeSelection.selected && self.itemCopy.naBeSelection.selected.id === 0
                        && tempScope.data.newData.naBeSelection.entries.length === 2) {
                        self.itemCopy.naBeSelection.selected = null;
                    }
                    self.itemCopy.naBeSelection.showMust = tempScope.data.newData.naBeSelection.showMust;
                    self.itemCopy.naBeSelection.entries = tempScope.data.newData.naBeSelection.entries;
                }
            });
            self.oldContractSelected = selected.id;
        }
    };

    self.save = function () {
        self.itemCopy.id = self.itemCopy.id || 0;
        $mdDialog.hide(self.itemCopy);
    };

    self.abort = function () {
        $mdDialog.cancel();
    };

    self.recalculateSummary = function () {
        var tempScope = {};
        dataGen.postAsForm(tempScope, {items: [self.itemCopy]}, "/rfx/freeformoffer/summary").then(function () {
            self.summary = tempScope.data;
        });
    };

    self.recalculateSummary();
}